import styled from 'styled-components';

import { Text } from '../../../../components/Text/Text';
import { COLORS, SPACE } from '../../../../theme/tokens';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

export const Intro = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACE[12]};
`;

export const Lead = styled(Text)`
  font-size: 15px;
  line-height: 1.5;
  color: ${COLORS.text};
`;

/** One list with its heading ("Redrawn", "Kept as it is"). */
export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const GroupTitle = styled(Text)`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${COLORS.textFaint};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Item = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${SPACE[8]};
  font-size: 13.5px;
  line-height: 1.45;
  color: ${COLORS.textMuted};

  svg {
    flex: none;
    margin-top: ${SPACE[2]};
    color: ${COLORS.accent};
  }
`;

/** Something the run leaves alone: its glyph is muted, not the accent. */
export const Kept = styled(Item)`
  svg {
    color: ${COLORS.textFaint};
  }
`;

/** Price, duration and when players see it. */
export const Facts = styled(List)`
  padding-top: ${SPACE[12]};
  border-top: 1px solid ${COLORS.hairline};
`;
